import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-644d8526"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "Material" }
const _hoisted_2 = ["src"]
const _hoisted_3 = {
  key: 0,
  class: "material-other"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "el-icon-upload" }, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "el-upload__text" }, [
  /*#__PURE__*/_createTextVNode("将图片拖到此处，或"),
  /*#__PURE__*/_createElementVNode("em", null, "点击上传")
], -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "el-upload__tip" }, "支持 jpg,png 格式，不超过20m", -1))

import { searchFormConfig } from './config/search.config'
import { contentTableConfig } from './config/content.config'
import { modalConfig } from './config/modal.config'
import { usePageSearch } from '@/hooks/userPageSearch'
import { usePageModal } from '@/hooks/usePageModal'
import { reactive, Ref, ref } from 'vue'
import { initEmptyParam } from '@/hooks/useInitParam'
import { getBeforeDate } from '@/utils/utils'
import { useStore } from '@/store'
import { useUploadMd5 } from '@/hooks/useUploadMd5'
import { ElMessage, ElMessageBox } from 'element-plus'
import { UploadFile } from 'element-plus/lib/el-upload/src/upload.type'
import PageContent from '@/components/PageContent.vue'
import { editPageData } from '@/service/main/system'


export default /*#__PURE__*/_defineComponent({
  __name: 'Manage',
  setup(__props) {

initEmptyParam()

const scrollContainer: Ref<HTMLDivElement | null> = ref(null)

var queryParam = {
  type: 0,
  longterm: 0,
  date: [getBeforeDate('1_year'), new Date().toISOString().slice(0, 10)]
}
const store = useStore()
store.commit('system/changeQueyryInfo', queryParam)

const resetCb = () => {
  return queryParam
}

const modalTitle = ref('新增')

const newCb = () => {
  modalTitle.value = '新增素材'
  defaultInfo.value = {
    replyKeyword: '',
    longterm: 0,
    validReplyDuration: 60
  }
  otherInfo.url = ''
  visible.value = false
  fileList.value = []
  files.value = []
  config.value = modalConfig
  config.value.formItems.forEach((obj) => {
    if (obj.field == 'titles') {
      obj.label = '标题'
      obj.multipleLimit = 1
      obj.placeholder = '请输入标题'
    }
  })
}

const editCb = (item: any) => {
  modalTitle.value = '编辑素材'
  if (item.url2) {
    otherInfo.url2 = item.url2
  } else {
    otherInfo.url = item.url
  }
  visible.value = item.type == 2 || item.type == 5
  defaultInfo.value.titles = item.titles.filter(Boolean)
  const lastUrl = item.url2 ? item.url2 : item.url
  if (lastUrl) {
    files.value.push(lastUrl)
    fileList.value = [
      {
        name: 'url' + lastUrl.substring(lastUrl.lastIndexOf('.')),
        url: lastUrl
      }
    ]
  } else {
    fileList.value = []
  }
  config.value.formItems.forEach((obj) => {
    if (obj.field == 'titles') {
      if (item.type == 4) {
        obj.label = '发送关键词'
        obj.multipleLimit = 1
        obj.placeholder = '请输入发送关键词'
      } else if (item.type == 5) {
        obj.label = '图片配文关键词'
        obj.multipleLimit = 3
        obj.placeholder =
          '请输入[图片配文关键词], 多个关键词请按Enter键逐个输入'
      } else {
        obj.label = '标题'
        obj.multipleLimit = 1
        obj.placeholder = '请输入标题'
      }
    }
  })
}

const handleRemove = (file: UploadFile) => {
  fileList.value = fileList.value.filter((f: UploadFile) => f.url !== file.url)
  files.value = files.value.filter((f: string) => f !== file.url)
}

const showTooltip = ref(false)
const tooltipLeft = ref(0)
const currentImageUrl = ref('')
const tooltipTop = ref(0)

const tooltipRef = ref<null | HTMLElement>(null)
let tooltipWidth = tooltipRef.value?.offsetWidth || 0
let tooltipHeight = tooltipRef.value?.offsetHeight || 0
let targetElement: HTMLElement

const getCellColor = (type: number) => {
  if (type == 2) {
    return 'dodgerblue'
  } else if (type == 5) {
    return 'darkorange'
  }
}

const imageLoaded = () => {
  tooltipWidth = tooltipRef.value?.offsetWidth || 0
  tooltipHeight = tooltipRef.value?.offsetHeight || 0

  const rect = targetElement.getBoundingClientRect()

  let rightTopX = rect.right
  let rightTopY = rect.top

  // 防止溢出右侧
  if (rightTopX + tooltipWidth > window.innerWidth) {
    rightTopX = window.innerWidth - tooltipWidth - 10
  }

  // 防止溢出底部
  if (rightTopY - tooltipHeight < 0) {
    rightTopY = tooltipHeight - store.state.system.scrollPosition + 10
  }

  // 防止溢出顶部（尽管根据你的逻辑这不太可能发生，但为了完整性还是包含）
  if (rightTopY + tooltipHeight > window.innerHeight) {
    rightTopY = window.innerHeight - tooltipHeight - 10
  }

  tooltipLeft.value = rightTopX + 10
  tooltipTop.value = rightTopY - 10
}

const handleMouseEnter = (
  row: any,
  column: any,
  cell: HTMLElement,
  event: MouseEvent
) => {
  if (column.property === 'typeName' && (row.type == 2 || row.type == 5)) {
    showTooltip.value = true
    currentImageUrl.value = row.url2 ? row.url2 : row.url

    targetElement = event.target as HTMLElement

    // 计算右上角坐标
    const rect = targetElement.getBoundingClientRect()

    const rightTopX = rect.right
    const rightTopY = rect.top

    tooltipLeft.value = rightTopX + 10
    tooltipTop.value = rightTopY - 10
  }
}

const handleMouseLeave = () => {
  showTooltip.value = false
  currentImageUrl.value = ''
}

const visible = ref(false)

const config = ref(modalConfig)

const handleChange = (item: any, value: any) => {
  if (item.type == 'select' && item.field == 'type') {
    visible.value = value == 2 || value == 5
  }
  config.value.formItems.forEach((obj) => {
    if (obj.field == 'titles') {
      if (value == 4) {
        obj.label = '发送关键词'
        obj.multipleLimit = 1
        obj.placeholder = '请输入发送关键词'
      } else if (value == 5) {
        obj.label = '图片配文关键词'
        obj.multipleLimit = 3
        obj.placeholder =
          '请输入[图片配文关键词], 多个关键词请按Enter键逐个输入'
      } else {
        obj.label = '标题'
        obj.multipleLimit = 1
      }
    }
  })
}

const previewImgUrl = ref(window.location.origin + '/previewImg.html?url=')

const [pageModalRef, defaultInfo, handleNewData, handleEditData] = usePageModal(
  newCb,
  editCb
)
const [pageContentRef, handleResetClick, handleSearchClick] =
  usePageSearch(resetCb)

const otherInfo = reactive({
  url: '',
  url2: ''
})

const handleValid = () => {
  if (visible.value) {
    if (files?.value.length > 0) {
      otherInfo.url = files.value[0]
      otherInfo.url2 = files.value[0]
      return true
    }

    ElMessage.error({ type: 'error', message: '请先上传图片' })

    return false
  } else {
    return true
  }
}

let selectRows = ref([])

const handleSelectionChange = (selection: any) => {
  if (selection.length > 0) {
    selectRows.value = selection.map((item: any) => item.id)
  }
}

const checkSelected = () => {
  if (selectRows.value.length == 0) {
    ElMessage({
      message: '请勾选修改的数据',
      type: 'warning'
    })
    return false
  }
  return true
}

const handleBatchDelete = () => {
  if (checkSelected()) {
    ElMessageBox.confirm('确认批量删除选中的素材吗？', '提示', {
      confirmButtonText: '确认',
      cancelButtonText: '取消',
      type: 'error',
      center: true
    }).then(() => {
      store.dispatch('system/deletePageDataAction', {
        pageName: 'materialManage',
        id: selectRows.value.join(',')
      })
    })
  }
}

const handleBatchSet = () => {
  if (checkSelected()) {
    ElMessageBox.confirm('确认批量设置选中的素材为长效素材吗？', '提示', {
      confirmButtonText: '确认',
      cancelButtonText: '取消',
      type: 'error',
      center: true
    }).then(async () => {
      await editPageData('/main/materialManage/batchSet', {
        ids: selectRows.value.join(',')
      })
      store.dispatch('system/getPageListAction', {
        pageName: 'materialManage',
        queryInfo: store.state.system.queryInfo
      })
    })
  }
}

const handleBatchCancel = () => {
  if (checkSelected()) {
    ElMessageBox.confirm('确认批量取消选中的素材为长效素材吗？', '提示', {
      confirmButtonText: '确认',
      cancelButtonText: '取消',
      type: 'error',
      center: true
    }).then(async () => {
      await editPageData('/main/materialManage/batchCancel', {
        ids: selectRows.value.join(',')
      })
      store.dispatch('system/getPageListAction', {
        pageName: 'materialManage',
        queryInfo: store.state.system.queryInfo
      })
    })
  }
}

const handleSortChange = (value: any) => {
  store.commit('system/changeOrderInfo', {
    orderBy: value.prop,
    orderType: value.order
  })
  const queryInfo = store.state.system.queryInfo
  pageContentRef.value?.getPageData(queryInfo)
}

const [
  uploadRef,
  extraData,
  files,
  action,
  beforeUpload,
  proveUpload,
  md5Upload,
  md5UploadTimeOut,
  onSuccess,
  onExceed
] = useUploadMd5()
const fileList = ref<any[]>([])

return (_ctx: any,_cache: any) => {
  const _component_PageSearch = _resolveComponent("PageSearch")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_PageModal = _resolveComponent("PageModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_PageSearch, {
      searchFormConfig: _unref(searchFormConfig),
      onResetBtnClick: _unref(handleResetClick),
      onSearchBtnClick: _unref(handleSearchClick)
    }, null, 8, ["searchFormConfig", "onResetBtnClick", "onSearchBtnClick"]),
    _createVNode(PageContent, {
      ref_key: "pageContentRef",
      ref: pageContentRef,
      contentTableConfig: _unref(contentTableConfig),
      pageName: "materialManage",
      deleteTip: "确认删除此素材吗？",
      onNewBtnClick: _unref(handleNewData),
      onEditBtnClick: _unref(handleEditData),
      onMouseEnter: handleMouseEnter,
      onMouseLeave: handleMouseLeave,
      onBatchDeleteBtnClick: handleBatchDelete,
      onBatchSetBtnClick: handleBatchSet,
      onBatchCancelBtnClick: handleBatchCancel,
      onSelectionChange: handleSelectionChange,
      onSortChange: handleSortChange
    }, {
      type: _withCtx((scope) => [
        (scope.row.type == 2 || scope.row.type == 5)
          ? (_openBlock(), _createBlock(_component_el_link, {
              key: 0,
              href: 
            previewImgUrl.value + (scope.row.url2 ? scope.row.url2 : scope.row.url)
          ,
              referrerpolicy: 'no-referrer',
              target: "_blank"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", {
                  style: _normalizeStyle({ color: getCellColor(scope.row.type), cursor: 'pointer' })
                }, _toDisplayString(scope.row.typeName), 5)
              ]),
              _: 2
            }, 1032, ["href"]))
          : _createCommentVNode("", true)
      ]),
      longterm: _withCtx((scope) => [
        _createTextVNode(_toDisplayString(scope.row.longterm == 0 ? '' : '是'), 1)
      ]),
      _: 1
    }, 8, ["contentTableConfig", "onNewBtnClick", "onEditBtnClick"]),
    _createVNode(_Transition, { name: "el-zoom-in-center" }, {
      default: _withCtx(() => [
        (showTooltip.value)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              ref_key: "tooltipRef",
              ref: tooltipRef,
              style: _normalizeStyle({ left: tooltipLeft.value + 'px', top: tooltipTop.value + 'px' }),
              class: "tooltip"
            }, [
              _createElementVNode("img", {
                src: currentImageUrl.value,
                alt: "",
                referrerpolicy: "no-referrer",
                onLoad: _cache[0] || (_cache[0] = ($event: any) => (imageLoaded()))
              }, null, 40, _hoisted_2)
            ], 4))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_component_PageModal, {
      ref_key: "pageModalRef",
      ref: pageModalRef,
      defaultInfo: _unref(defaultInfo),
      modalConfig: config.value,
      title: modalTitle.value,
      pageName: "materialManage",
      otherInfo: otherInfo,
      validOtherInfo: handleValid,
      onChange: handleChange
    }, {
      default: _withCtx(() => [
        (visible.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createVNode(_component_el_upload, {
                ref_key: "uploadRef",
                ref: uploadRef,
                drag: "",
                "auto-upload": true,
                action: _unref(action),
                data: _unref(extraData),
                "file-list": fileList.value,
                "on-change": _unref(md5Upload),
                "before-upload": _unref(md5UploadTimeOut),
                "list-type": "picture",
                accept: ".jpg, .jpeg, .png",
                "on-success": _unref(onSuccess),
                "on-exceed": _unref(onExceed),
                "on-remove": handleRemove,
                limit: 1
              }, {
                tip: _withCtx(() => [
                  _hoisted_6
                ]),
                default: _withCtx(() => [
                  _hoisted_4,
                  _hoisted_5
                ]),
                _: 1
              }, 8, ["action", "data", "file-list", "on-change", "before-upload", "on-success", "on-exceed"])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["defaultInfo", "modalConfig", "title", "otherInfo"])
  ]))
}
}

})